import { StatementOriginRequiredInputConstraint } from './collection-revision.interface';

export type StatementOriginScope = 'SYSTEM' | 'TEAM';

export interface StatementOriginRow {
  readonly id: string;
  readonly entity_profile_id: string;
  readonly scope: StatementOriginScope;
  readonly display_name: string;
  readonly icon_hash: string | null;
  readonly icon_url: string | null;
  readonly description: string | null;
  readonly website_url: string | null;
}

export interface StatementOriginCatalogPage {
  readonly items: readonly StatementOriginRow[];
  readonly page: number;
  readonly size: number;
  readonly total_elements: number;
  readonly total_pages: number;
  readonly constraint: StatementOriginRequiredInputConstraint;
  readonly allow_create: boolean;
}

export interface StatementOriginCatalogQuery {
  readonly constraint: StatementOriginRequiredInputConstraint;
  readonly search?: string | null;
  readonly page: number;
  readonly size: number;
}

export interface CollectionRevisionScope {
  readonly collectionId: string;
  readonly revisionId: string;
}

export const STATEMENT_ORIGIN_VALIDATION_ERROR_CODES = [
  'STATEMENT_ORIGIN_NOT_VISIBLE',
  'STATEMENT_ORIGIN_CONSTRAINT_VIOLATION',
  'STATEMENT_ORIGIN_INACTIVE',
  'STATEMENT_ORIGIN_NOT_FOUND',
  'STATEMENT_ORIGIN_NAME_COLLISION',
  'STATEMENT_ORIGIN_OBSERVER_SCOPE_VIOLATION',
  'STATEMENT_ORIGIN_CATALOG_UNAVAILABLE',
  'STATEMENT_ORIGIN_RESOLUTION_FAILED',
  'STATEMENT_ORIGIN_EVIDENCE_MISSING',
] as const;

export type StatementOriginValidationErrorCode =
  (typeof STATEMENT_ORIGIN_VALIDATION_ERROR_CODES)[number];

const STATEMENT_ORIGIN_VALIDATION_ERROR_CODE_SET: ReadonlySet<string> = new Set(
  STATEMENT_ORIGIN_VALIDATION_ERROR_CODES,
);

export function isStatementOriginValidationErrorCode(
  value: string | null | undefined,
): value is StatementOriginValidationErrorCode {
  return (
    typeof value === 'string' &&
    STATEMENT_ORIGIN_VALIDATION_ERROR_CODE_SET.has(value)
  );
}
